<!-- Botón que abre el drawer -->
<button nz-button nzType="text" (click)="openDrawer()" style="color: white;">
  <i nz-icon nzType="user" nzTheme="outline" style="color: white;"></i>
  {{ user?.firstName || "Usuario" }}
  <i nz-icon nzType="menu" nzTheme="outline"></i>
</button>

<!-- Drawer lateral -->
<nz-drawer
  [nzVisible]="isDrawerVisible"
  nzTitle="Configurations"
  nzPlacement="right"
  [nzClosable]="false"
  [nzWidth]="280"
  (nzOnClose)="closeDrawer()"
>
  <ng-container *nzDrawerContent>
    <ul nz-menu nzMode="inline" [nzSelectable]="false">
      @if(hasPermissionToConfig){
        <li nz-menu-item (click)="goTo('object-manager')">
          <nz-icon nzType="user" nzTheme="outline" />
           <span>Object Manager</span>
         </li>
   
         <li nz-menu-item (click)="goTo('list-of-val')">
          <nz-icon nzType="unordered-list" nzTheme="outline" />
           <span>List of Values</span>
         </li>
   
         <li nz-menu-item (click)="goTo('users')">
          <nz-icon nzType="user" nzTheme="outline" />
           <span>Users</span>
         </li>
         <li nz-menu-item (click)="goTo('roles')">
       <nz-icon nzType="lock" nzTheme="outline" />
           <span>Roles</span>
         </li>
      }
      
      <li nz-menu-item (click)="logout()">
        <i nz-icon nzType="logout"></i>
        <span>Cerrar sesión</span>
      </li>
    </ul>
  </ng-container>
</nz-drawer>
